import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {
    getActiveIndex,
    getActiveIndexText,
    getMaxIndex,
    selectDataTableByType
} from "@/helpers/datatable-filter-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";

export class LayerInfoInfoItemFilterNavigationComponent extends HTMLElement {
    constructor(){
        super();

        const activeFilter = getActiveFilter()

        const activeIndexText = getActiveIndexText()
        if(isNaN(activeIndexText)) {
            return
        }

        if(activeFilter !== undefined) {

            console.log(activeIndexText)

            const maxIndex = getMaxIndex()

            const template = document.createElement('template');

            template.innerHTML =
                `<div class="ml-3 mr-3 pl-2 pt-2 pb-1 pr-2">
            <div class="row">
                <div class="col-1 pl-0">
                    <button data-type="previous" class="btn btn-sm btn-outline-secondary icon-btn">
                        <span class="fa fa-angle-left"></span>
                    </button>
                </div>
                <div class="col-4 pl-0 text-center">
                    <div style="margin-top:3px !important">
                        ` + (activeIndexText + 1) + ` / <span id="spnKVDatatableTotalIndex">` + maxIndex + `</span>
                    </div>
                </div>
                <div class="col-1 pl-0">
                    <button data-type="next" class="btn btn-sm btn-outline-secondary icon-btn float-right">
                        <span class="fa fa-angle-right"></span>
                    </button>
                </div>
                <div class="col-6">
                    <button id="btnShowFilterLayerResult" class="btn btn-outline-secondary btn-sm borderless float-right">
                        <span class="fa fa-chevron-left"></span> Filter resultaat
                    </button>
                </div>
            </div>
        </div>`

            initWebComponent(this, template)

            this.addEventListener('click', (element) => {
                let type = element.target.dataset.type
                if (type === undefined) {
                    type = element.target.parentElement.dataset.type
                }

                if (type !== undefined) {
                    selectDataTableByType(type)
                }

                if(element.target.id=== 'btnShowFilterLayerResult') {
                    showLayerInfoButton('layer-info-filter')
                }
            })
        }
    }
}

